export default __webpack_public_path__ + "static/media/check-white.17115fc1.svg";